import { Outlet, useLocation } from 'react-router-dom';
import { useStudyTimeTracker } from '../hooks/useStudyTimeTracker';
import { useAuth } from '../hooks/useAuth';
import { ROLES } from '../utils/roles';
import ErrorBoundary from './ErrorBoundary';
import BottomNav from './BottomNav';

const HIDE_NAV_PREFIXES = [
  '/student/journeys/tamkeen',
  '/student/train/',
  '/student/decks/',
  '/student/quizzes/',
  '/embed',
  '/flashcards/embed',
  '/drills/embed',
  '/mix/embed',
];

export default function AppLayout() {
  useStudyTimeTracker();
  const { role } = useAuth();
  const { pathname } = useLocation();

  const isStudent = role === ROLES.STUDENT;
  const hideNav = HIDE_NAV_PREFIXES.some(p => pathname.startsWith(p))
    || /\/student\/journeys\/[^/]+\/step\//.test(pathname);
  const showBottomNav = isStudent && !hideNav;

  return (
    <ErrorBoundary>
      <div className={showBottomNav ? 'app-with-bottom-nav' : ''}>
        <Outlet />
        {showBottomNav && <BottomNav />}
      </div>
    </ErrorBoundary>
  );
}
